var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolbarLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2720_9292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.667 14.6667C12.9533 15.0495 13.3186 15.3662 13.738 15.5954C14.1575 15.8245 14.6213 15.9608 15.0981 15.9949C15.5749 16.0291 16.0534 15.9603 16.5012 15.7932C16.9491 15.6262 17.3557 15.3648 17.6937 15.0267L19.6937 13.0267C20.3009 12.3981 20.6368 11.556 20.6292 10.6821C20.6216 9.80807 20.2711 8.97202 19.6531 8.354C19.035 7.73597 18.199 7.38541 17.325 7.37781C16.451 7.37022 15.609 7.7062 14.9803 8.31339L13.8337 9.45339",
    stroke: "#2A3D4A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3335 13.3333C15.0472 12.9506 14.6819 12.6339 14.2624 12.4047C13.843 12.1755 13.3791 12.0392 12.9024 12.0051C12.4256 11.971 11.9471 12.0397 11.4992 12.2068C11.0514 12.3739 10.6447 12.6353 10.3068 12.9733L8.3068 14.9733C7.69961 15.602 7.36363 16.444 7.37122 17.318C7.37881 18.192 7.72938 19.028 8.3474 19.646C8.96543 20.2641 9.80147 20.6146 10.6755 20.6222C11.5495 20.6298 12.3915 20.2938 13.0201 19.6867L14.1601 18.5467",
    stroke: "#2A3D4A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2720_9292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbarLink);
export default __webpack_public_path__ + "static/media/toolbar-link.3460443cbf7d2458678b2b55aceb5471.svg";
export { ForwardRef as ReactComponent };